// extracted by mini-css-extract-plugin
export default {"button":"theme_button__6uqQS","text":"theme_text__X7k2h"};